<template id="map-template">
  <div class="homeview-messagecenter-data">
    <div class="circle-chart">
      <div
        class="task-item"
        v-bind:class="{
          item1: index == 0,
          item2: index == 1,
          item3: index == 2,
        }"
        v-for="(item, index) in equipList"
        :key="index"
      >
        <div class="task-icon-wrapper">
          <span
            v-bind:class="{
              font1: index == 0,
              font2: index == 1,
              font3: index == 2,
            }"
            >{{ item.Count }}</span
          >
          <div class="task-icon"></div>
        </div>
        <div class="task-status">{{ item.Name }}</div>
      </div>
    </div>
    <div class="header">
      <span class="header-title">设备预警日志</span>
      <div class="arrow-pic"></div>
    </div>
    <div class="table-chart">
      <el-table
        :data="tableData"
        ref="multipleTable"
        border
        style="width: 100%"
        fixed
        :show-header="false"
      >
        <el-table-column
          prop="startTs"
          label="上报时间"
          :formatter="formatterDate"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="equipmentCode"
          label="设备名称"
          :formatter="formatterDeviceName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="warnDesc"
          label="预警信息"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
//import MyApis from "../../../apis";

export default {
  name: "EquipRightPanel",
  componentName: "EquipRightPanel",

  props: {
    deviceList: {
      type: Array,
    },
    logList: {
      type: Array,
    },
    equipmentList: {
      type: Array,
    },
  },
  data() {
    return {
      tableData: this.logList,

      realtimeData: [
        { Extend1: "故障", ItemValue: 10 },
        { Extend1: "故障", ItemValue: 10 },
        { Extend1: "故障", ItemValue: 10 },
      ],
      equipList: this.deviceList, // 把传过来的值赋值给新的变量
      allEquipmentList: this.equipmentList,
    };
  },
  watch: {
    deviceList(newVal) {
      this.equipList = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    },
    logList(newVal) {
      this.tableData = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    },
    equipmentList(newVal) {
      this.allEquipmentList = newVal; //对父组件传过来的值进行监听，如果改变也对子组件内部的值进行改变
    },
  },
  created() {},
  mounted: function () {},
  methods: {
    // 格式化表格时间
    formatterDate(row) {
      return this.getDate(row.startTs);
    },
    // 时间戳转xxxx-xx-xx
    getDate(time) {
      let tempTime = new Date(time);
      let year = tempTime.getFullYear();
      let month = tempTime.getMonth() + 1;
      let day = tempTime.getDate();
      let hour = tempTime.getHours();
      let min = tempTime.getMinutes();
      let sec = tempTime.getSeconds();
      return (
        year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec
      );
    },
    //根据code找设备名称
    formatterDeviceName(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const deviceName = this.allEquipmentList
        .map((item) => {
          if (item.equipmentCode == data) return item.equipmentName;
        })
        .join("");
      if (deviceName == null || deviceName == "") {
        return data;
      }
      return deviceName;
    },
  },
};
</script>